import { Box, type SelectOption, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Popover from 'modules/core/components/Popover'
import i18n from 'modules/core/lib/i18n'

import FilterSelect from 'modules/employees/components/FaceRecognition/Logs/Content/Table/FilterSelect'
import { STATUS } from 'modules/employees/components/FaceRecognition/Logs/Content/Table/constants'
import type { ClockPicturesConfigFilters } from 'modules/employees/components/FaceRecognition/Logs/Content/Table/forms'

interface OptionsProps {
  filtersForm: ClockPicturesConfigFilters
  onFilterStatus: (status: string) => void
}

interface FilterGroup {
  filter_name: string
  options: SelectOption[]
}

const statusOptions = (): SelectOption[] => {
  return [
    {
      label: i18n.t('time_tracking.settings.face_recognition.filter.all'),
      value: STATUS.allPictures,
    },
    {
      label: i18n.t('time_tracking.settings.face_recognition.filter.valid'),
      value: STATUS.isValid,
    },
    {
      label: i18n.t('time_tracking.settings.face_recognition.filter.invalid'),
      value: STATUS.isInValid,
    },
  ]
}

const recordTypeOptions = (): SelectOption[] => {
  return [
    {
      label: i18n.t('time_tracking.settings.face_recognition.filter.clocked_in'),
      value: STATUS.isClockedIn,
    },
    {
      label: i18n.t('time_tracking.settings.face_recognition.filter.clocked_out'),
      value: STATUS.isClockedOut,
    },
  ]
}

const filters = (): FilterGroup[] => [
  {
    filter_name: i18n.t('time_tracking.settings.face_recognition.filter.status'),
    options: statusOptions(),
  },
  {
    filter_name: i18n.t('time_tracking.settings.face_recognition.filter.record_type'),
    options: recordTypeOptions(),
  },
]

const Options = observer(({ filtersForm, onFilterStatus }: OptionsProps) => {
  const statusField = filtersForm.get('status')

  return (
    <Box padding="s24" gap="s16">
      <Box gap="s8" alignItems="flexStart">
        <Text size="300" weight="medium">
          {i18n.t('surveys.index.table.filters.title')}
        </Text>
        <Text size="300" color="grey800">
          {i18n.t('surveys.index.table.filters.description')}
        </Text>
      </Box>
      {filters().map(({ filter_name, options }, idx) => (
        <Select
          key={idx}
          label={filter_name}
          onChange={() => onFilterStatus(statusField.value)}
          field={statusField}
          options={options}
          none={i18n.t('filters.filter.none')}
        />
      ))}
    </Box>
  )
})
interface Props {
  filtersForm: ClockPicturesConfigFilters
  onFilterStatus: (status: string) => void
}

const Filters = ({ filtersForm, onFilterStatus }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box height="full">
      <Popover open={open} toggle={toggle} attachment="top center" size="auto">
        <FilterSelect toggle={toggle} open={open} />
        <Options filtersForm={filtersForm} onFilterStatus={onFilterStatus} />
      </Popover>
    </Box>
  )
}

export default observer(Filters)
